/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AlertPartialUpdate
 */
export interface AlertPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof AlertPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertPartialUpdate
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertPartialUpdate
     */
    level?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertPartialUpdate
     */
    isOpen?: boolean;
}

export function AlertPartialUpdateFromJSON(json: any): AlertPartialUpdate {
    return AlertPartialUpdateFromJSONTyped(json, false);
}

export function AlertPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'isOpen': !exists(json, 'is_open') ? undefined : json['is_open'],
    };
}

export function AlertPartialUpdateToJSON(value?: AlertPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'message': value.message,
        'level': value.level,
        'is_open': value.isOpen,
    };
}


